import React, { useState } from 'react';
import Axios from 'axios';
import * as Routes from '@/modules/routes';

interface RunSyncProps {
  closeModal: () => void;
  onSyncStarted: () => void;
  subscriberId: number;
}

const RunSync = ({ closeModal, onSyncStarted, subscriberId }: RunSyncProps) => {
  const [hasError, setHasError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const runSync = () => {
    setIsSubmitting(true);
    Axios.get(Routes.plato_api_run_sync_subscriber_auto_roster_syncs_path(subscriberId))
      .then(() => {
        onSyncStarted();
        closeModal();
      })
      .catch(() => setHasError(true))
      .finally(() => setIsSubmitting(false));
  };

  if (hasError) {
    return (
      <div className="error">There was an error. Please reload the page and try again.</div>
    );
  }

  return (
    <div>
      <h1>Are you sure you want to run a roster sync for this district?</h1>
      <ul className="bullet_list pt20">
        <li>This sync can take up to a few hours</li>
        <li>This sync may remove access to programs from teachers and students</li>
        <li>Remember to check if there is already a sync running from this district</li>
      </ul>
      <footer>
        <button
          className="btn btn--link-purple"
          type="button"
          value="Cancel"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          className="btn btn--purple"
          disabled={isSubmitting}
          type="button"
          onClick={runSync}
        >
          Run Sync
        </button>
      </footer>
    </div>
  );
};

export default RunSync;
